import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=fcd2e494"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=fcd2e494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports